<script setup lang="ts">
import cornerArrows from '@/assets/images/banner/window-size/corner-arrows-outward.svg';
</script>

<template>
	<div class="fixed top-0 left-0 z-90 flex size-full flex-col items-center justify-center bg-neutral-700 p-4">
		<div class="z-10 w-full max-w-xl min-w-fit">
			<div class="relative flex size-full min-h-fit min-w-fit flex-col rounded-3xl bg-white p-6">
				<!-- Modal body -->
				<div class="flex max-w-xl flex-col items-center justify-center p-4">
					<div class="flex h-fit flex-row items-center justify-center space-x-3">
						<svg width="36" height="36" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g id="check-box 1">
								<g id="Group">
									<g id="check-box-outline">
										<path
											id="Vector"
											d="M15.8944 19.4389L13.6389 21.6944L20.8889 28.9444L37 12.8333L34.7444 10.5778L20.8889 24.4333L15.8944 19.4389ZM33.7778 33.7778H11.2222V11.2222H27.3333V8H11.2222C9.45 8 8 9.45 8 11.2222V33.7778C8 35.55 9.45 37 11.2222 37H33.7778C35.55 37 37 35.55 37 33.7778V20.8889H33.7778V33.7778Z"
											fill="#1C64F2"
										/>
									</g>
								</g>
							</g>
						</svg>
					</div>

					<p class="mt-3 text-center text-xl font-bold text-Qblack-900">Thank you for signing up.</p>

					<p class="mt-3 text-center text-base font-normal text-Qblack-900">
						Your browser window is too small for our content. Make your window larger by dragging the corners of the
						browser.
					</p>
					<p class="text-center text-base font-normal text-Qblack-900">
						Need more help?
						<a
							href="https://help.qweebi.com/en/articles/11194267-why-do-i-see-the-message-your-browser-window-is-too-small-for-our-content"
							target="_blank"
							rel="noreferrer noopener"
							class="text-blue-500"
							>See this help article.</a
						>
					</p>

					<img :src="cornerArrows" alt="Resize your browser window" class="mt-4 h-auto w-48" />
				</div>
			</div>
		</div>
	</div>
</template>
